export default "__VITE_ASSET__788f86bd__"